module.exports = __webpack_public_path__ + "assets/img/ceremonyBg.6a7f361d.png";